import React, { FC } from "react"

import { InputProps } from "../../utils/Interfaces"

export const Checkbox: FC<InputProps> = ({
    name,
    value,
    label,
    posting,
    checked,
    disabled,
    required,
    changeHandler,
}) => {
    const isDisabled = disabled ? disabled : posting

    return (
        <React.Fragment>
            <div className="flex space-x-3 rounded accent-orange-600">
                <input
                    type="checkbox"
                    id={name}
                    name={name}
                    value={value}
                    checked={checked}
                    required={required}
                    disabled={isDisabled}
                    onChange={changeHandler}
                    aria-describedby={name}
                    className="h-4 w-5 mt-1 rounded-lg border-gray-300 text-orange-600 shadow-sm focus:border-orange-300 focus:ring-0 focus:ring-orange-200 focus:ring-opacity-50 focus:ring-offset-0 disabled:cursor-not-allowed disabled:text-gray-400"
                />

                <label htmlFor={name} className="w-full cursor-pointer text-sm ">
                    {
                        label
                    }
                </label>
            </div>
        </React.Fragment>
    )
}